import * as React from 'react';
import * as Images from 'pos/Images';

import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as SalesStore from '../SalesStore';
import { Content, Header, PosScreen, UserButton } from 'pos/ui';
import { AvailableUserDTO, Res, Permission, TicketLineDTO } from 'core/api';
import { Command } from 'pos/common';
import { RestaurantFacade } from 'pos/facades';
import { Modal } from 'core/ui-next/modal';
import { VStack, Text, Grid, Box } from '@chakra-ui/react';

type Props = { users: AvailableUserDTO[]; creatorUserId: number } & Modal.Actions<AvailableUserDTO>;

function SelectUsersScreen(props: Props) {
	const { users, cancel, creatorUserId, close } = props;

	const onUserSelect = (user: AvailableUserDTO) => close(user);

	const selectedUserRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		selectedUserRef.current?.scrollIntoView({ block: 'center', inline: 'center' });
	}, []);


	return <PosScreen screenId='SET_TICKET_LINE_CREATOR' size='medium'>
		<Header title={Res.Web.SET_TICKET_LINE_CREATOR()} image={Images.SetTicketLineCreator} onClose={cancel} />
		<Content>
			<VStack w='full' paddingY={'6'} paddingX={'12'} gap={'6'} height={'full'}>
				<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SET_TICKET_LINE_CREATOR_USER_SELECTION_LBL()}</Text>
				<Grid w='full' justifyContent={'center'} columnGap={'1'} rowGap={'9'} templateColumns={'repeat(auto-fill, 6rem)'} overflow={'auto'}>
					{users.map(user => {
						const isSelected = user.Id === creatorUserId;
						return (
							<Box key={user.Id} ref={isSelected ? selectedUserRef : undefined}>
								<UserButton user={user} onSelect={onUserSelect} selected={isSelected} />
							</Box>
						);
					})}
				</Grid>
			</VStack>
		</Content>
	</PosScreen>;
}

declare global {
	interface CommandType {
		setTicketLineCreator: (ticketLine: TicketLineDTO) => Promise<Result>
	}
}

Command.register('setTicketLineCreator', Preconditions.ensure(Permission.Ticket_ChangeOpenerUser), async (ticketLine: TicketLineDTO): Promise<Result> => {
	const users = await RestaurantFacade.getAvailableUsers();
	const creatorUserId = ticketLine.UserId;
	const selectedUserResult = await Modal.show(SelectUsersScreen, { users, creatorUserId });

	if (!selectedUserResult.ok)
		return Result.error();

	await SalesStore.setTicketLineCreator(selectedUserResult.value, ticketLine);

	return Result.ok();

});